import { type Client, type Sink, createClient, type ClientOptions } from 'graphql-ws';

import { type Operation, type FetchResult, ApolloLink, Observable } from 'apollo-link';
import { type FormattedExecutionResult, print } from 'graphql';
import { ApolloError } from 'apollo-client';

// code borrowed from WebSocketLink.ts but modified to hit subscriptions
export function getWebSocketURL(): string {
	let WEBSOCKET_URL: string;

	if (process.env.NODE_ENV === 'testing') {
		WEBSOCKET_URL = `wss://pug.jira-dev.com/gateway/api/graphql/subscriptions`;
	} else if (process.env.NODE_ENV !== 'production') {
		// In dev mode this allows the local dev proxy to use the WebSocket host
		// that matches the backend origin host. The __backendOriginHost is only
		// available with local dev server.
		const host = (window as any)?.__backendOriginHost || window?.location?.host;

		WEBSOCKET_URL = `wss://${host}/gateway/api/graphql/subscriptions`;
	} else {
		WEBSOCKET_URL = `wss://${window?.location?.host ?? 'pug.jira-dev.com'}/gateway/api/graphql/subscriptions`;
	}

	return WEBSOCKET_URL;
}
export class GraphQLWsLink extends ApolloLink {
	private client: Client;

	constructor(options: ClientOptions) {
		super();
		this.client = createClient(options);
	}

	public request(operation: Operation): Observable<FetchResult> {
		return new Observable((observer) => {
			return this.client.subscribe<FetchResult>({ ...operation, query: print(operation.query) }, {
				next: observer.next.bind(observer),
				complete: observer.complete.bind(observer),
				error: (err) => {
					if (err instanceof Error) {
						return observer.error(err);
					}

					return observer.error(
						new ApolloError({
							graphQLErrors: Array.isArray(err) ? err : [err],
						}),
					);
				},
				// casting around a wrong type in graphql-ws, which incorrectly expects `Sink<ExecutionResult>`
			} satisfies Sink<FormattedExecutionResult> as any);
		});
	}
}

let wsLink: GraphQLWsLink | undefined;

export function getAGGWebSocketLinkInstance(): GraphQLWsLink {
	const WEBSOCKET_URL = getWebSocketURL();
	if (!wsLink) {
		wsLink = new GraphQLWsLink({
			url: () => {
				return WEBSOCKET_URL;
			},
			shouldRetry: () => {
				return true;
			},
			retryAttempts: 5,
		});
	}
	return wsLink;
}
